export default "dist/images/block-text-plain.1b415a1.png";